export default __webpack_public_path__ + "static/irlBreak-d6415bd6927808fea9aff1540114b1f8.mp3";